import { render, staticRenderFns } from "./BaseColor.vue?vue&type=template&id=36c16502&functional=true&"
import script from "./BaseColor.vue?vue&type=script&lang=ts&"
export * from "./BaseColor.vue?vue&type=script&lang=ts&"
import style0 from "./BaseColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports